import React, { useEffect } from "react";
import { motion } from "framer-motion";

export const TentangKami = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-20 text-center text-cyan-600 flex-col justify-center relative bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-base sm:text-lg md:text-xl font-normal uppercase mb-1 md:mb-2 text-cyan-600"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          PT CAKRAWALA JAKARTA KREATIF
        </motion.h2>

        <motion.p
          className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black mx-auto mb-8 md:mb-16 text-cyan-600 px-4"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          TENTANG KAMI
        </motion.p>

        <div className="max-w-6xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <h3 className="text-xl font-bold text-cyan-900 mb-4">
                Profil Perusahaan
              </h3>
              <div className="text-lg text-cyan-800 space-y-6">
                <p>
                  Selamat datang di PT Cakrawala Jakarta Kreatif, sebuah badan
                  usaha kreatif yang telah berbadan hukum dan berkomitmen
                  menghadirkan solusi inovatif untuk mendorong perkembangan
                  kreativitas serta potensi di Jakarta. Kami bukan sekadar
                  platform kolaborasi, melainkan ekosistem yang menghadirkan
                  pengalaman menyeluruh dalam dunia seni, budaya, dan kegiatan
                  kreatif.
                </p>

                <p>
                  Melalui layanan yang kami sediakan, masyarakat dapat dengan
                  mudah menemukan, mengikuti, dan terlibat dalam beragam
                  kegiatan inspiratif, mulai dari pameran seni, festival budaya,
                  hingga lokakarya dan seminar. Seluruh proses dirancang untuk
                  memberikan kemudahan, keamanan, dan kenyamanan dalam setiap
                  langkahnya, demi menciptakan pengalaman yang bermakna.
                </p>

                <p>
                  Tidak hanya menjadi ruang untuk pendaftaran acara, platform
                  ini juga menjadi wadah bagi para pelaku kreatif untuk berbagi
                  ide, menampilkan karya, serta membangun jejaring kolaborasi.
                  Kami percaya, kreativitas tumbuh melalui interaksi,
                  keterbukaan, dan kontribusi nyata dalam komunitas.
                </p>

                <p>
                  Jadikan setiap momen kreatif lebih bermakna bersama kami.
                  Bergabunglah dengan ribuan individu dan komunitas yang telah
                  mempercayakan perjalanan pengembangan potensi dan karya mereka
                  di sini. Mari melangkah bersama menuju dunia kreativitas yang
                  tanpa batas.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
